import React from "react";
import {
  Text,
  HStack,
  Switch,
} from "@chakra-ui/react";

function FavouritesOnly(props) {
  return (
      <HStack spacing={4}>
        <Switch size={props.size} colorScheme="teal" onChange={props.onChange} isChecked={props.isChecked}></Switch>
        <Text fontSize={props.size} color="white" {...props.textProps}>Favorites</Text>
      </HStack>
  );
}

export default FavouritesOnly;